import { render, staticRenderFns } from "./CarePlanManage.vue?vue&type=template&id=d53df72a&scoped=true"
import script from "./CarePlanManage.vue?vue&type=script&lang=js"
export * from "./CarePlanManage.vue?vue&type=script&lang=js"
import style0 from "./CarePlanManage.vue?vue&type=style&index=0&id=d53df72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53df72a",
  null
  
)

export default component.exports